import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mountain, Lock } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please enter email and password");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      sessionStorage.setItem("adminToken", response.data.token);
      sessionStorage.setItem("adminEmail", response.data.email);
      toast.success("Login successful");
      navigate("/admin");
    } catch (e) {
      console.error("Login error:", e);
      toast.error("Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#1A2F23] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Mountain className="w-12 h-12 text-[#D4A017] mx-auto mb-4" strokeWidth={1.5} />
          <h1 className="font-heading text-3xl font-bold text-white">Admin Login</h1>
          <p className="text-white/60 mt-2">ekvalleys.com management</p>
        </div>

        <div className="bg-[#F7F6F2] border-2 border-[#D1CFC5] rounded-xl p-8">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-[#1A1915] font-medium">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-white border-2 border-[#D1CFC5]"
                placeholder="admin@ekvalleys.com"
                data-testid="admin-email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-[#1A1915] font-medium">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-white border-2 border-[#D1CFC5]"
                placeholder="••••••••"
                data-testid="admin-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#2C4A3B] hover:bg-[#1A2F23] text-white font-semibold py-3 rounded-lg border-2 border-[#1A1915] btn-shadow"
              data-testid="admin-login-btn"
            >
              <Lock className="w-4 h-4 mr-2" />
              {loading ? "Logging in..." : "Login"}
            </Button>
          </form>

          <p className="text-center text-[#5C5A52] text-sm mt-6">
            First time? Use admin@ekvalleys.com with your chosen password.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
